import React from 'react';
import { Search, X } from 'lucide-react';
import '../styles/SearchBar.css';

const SearchBar = ({ searchQuery, setSearchQuery, translations, language }) => {
  const t = translations[language];

  return (
    <div className="search-container">
      <div className="search-bar">
        <Search className="search-icon" />
        <input
          type="text"
          placeholder={t.searchPlaceholder}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery('')}
            className="search-clear"
          >
            <X className="search-clear-icon" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;